/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"

import Footer from "./Footer"
import Header from "./Header"

export default function Layout({ className, children }) {
  return (
    <div className={`zenduty-layout min-h-screen flex flex-col ${className}`}>
      <Header />
      <main className="zenduty-main flex-grow mb-48">{children}</main>
      <Footer />
    </div>
  )
}
